var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49994 14.6164C13.4343 14.6164 15.717 13.9834 15.9374 11.4427C15.9374 8.9037 14.3459 9.06697 14.3459 5.95173C14.3459 3.51838 12.0395 0.749756 8.49994 0.749756C4.96036 0.749756 2.65393 3.51838 2.65393 5.95173C2.65393 9.06697 1.06244 8.9037 1.06244 11.4427C1.28377 13.993 3.56649 14.6164 8.49994 14.6164Z",
    stroke: "#001860",
    strokeWidth: 0.851351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5901 17.2498C9.39651 18.5751 7.5345 18.5908 6.32947 17.2498",
    stroke: "#001860",
    strokeWidth: 0.851351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d27c1fe9.svg";
export { ForwardRef as ReactComponent };